export const FETCH_CREATE_USER = 'FETCH_CREATE_USER';
export const FETCH_CREATE_USER_SUCCESS = 'FETCH_CREATE_USER_SUCCESS';
export const FETCH_CREATE_USER_FAILURE = 'FETCH_CREATE_USER_FAILURE';
export const FETCH_CREATE_USER_RESET = 'FETCH_CREATE_USER_RESET';
